import { useNavigate } from "react-router-dom";
import Navbar from "../components/NavBar";
import { useAppDispatch, useAppSelector } from "../store/store";
import FavoritesActions from "../store/favorites/action";
import ProductCard from "../components/ProductCard";
import Clothes from "../models/clothes/clothes.model";

const FavoritesPage = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { user } = useAppSelector((s) => s.auth);
    const { favorites } = useAppSelector((s) => s.favorites);

    const onItemClick = (item: Clothes) => {
        navigate("/item", { state: { item } });
    };

    const onToggleFavorite = (item: Clothes, e: React.MouseEvent) => {
        e.stopPropagation();
        FavoritesActions.removeItem(item, favorites, dispatch);
    };

    return (
        <div className="min-h-screen bg-[#f8f2ed] font-manrope">
            <Navbar />
            <div className="max-w-6xl mx-auto px-4 py-6">
                <h1 className="text-2xl font-semibold text-[#704e37] mb-6">Të preferuarat</h1>
                {favorites && favorites.length > 0 ? (
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
                        {favorites.map((item) => (
                            <ProductCard
                                key={`${item.seller_id}_${item.id}`}
                                item={item}
                                isFavorite
                                onToggleFavorite={onToggleFavorite}
                                onClick={onItemClick}
                                currentUserId={user?.id}
                            />
                        ))}
                    </div>
                ) : (
                    <p className="text-gray-500">Nuk keni asnjë të preferuar.</p>
                )}
            </div>
        </div>
    );
};

export default FavoritesPage;
